// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xRegex } from "@conklin/XDL/Utilities/validation";

export const xMask = {
    phoneNumber: (value: string) => {
        if (!value) {
            return "";
        }
        return value.replace(/^(\d{3})(\d{3})(\d)/, "$1-$2-$3");
    },
    phoneNumberUS: (value?: string) => {
        if (!value) {
            return "";
        }
        return value.replace(/^(\d{3})(\d{3})(\d)/, "($1) $2-$3");
    },

    addressPhone: (value: string) => {
        const masked = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if (!masked) {
            return "";
        }
        return !masked[2] ? masked[1] : `(${masked[1]}) ${masked[2]}-${masked[3] || ""}`;
    },
    qty: (value: string) => {
        let transformedValue = value;
        if (value) {
            const cleanedValue = value.toString().replace(xRegex.qty, "");
            transformedValue = cleanedValue || "1";
        }
        return transformedValue;
    },
    decimal: (value: string) => {
        let transformedValue = value;
        // Accepting only one ( . ) and only numbers
        if (value) {
            transformedValue = value.replace(xRegex.decimal, "");
            const dotCount = transformedValue.split(".").length - 1;
            if (dotCount > 1) {
                transformedValue = transformedValue.substring(0, transformedValue.lastIndexOf("."));
            }
            // Ensure there are at most two digits after the dot
            const dotIndex = transformedValue.indexOf(".");
            if (dotIndex !== -1 && transformedValue.length - dotIndex > 3) {
                transformedValue = transformedValue.substring(0, dotIndex + 3);
            }
        }
        return transformedValue;
    },
    removeTags: (value?: string) => {
        const decodeSymbol: { [key: string]: string } = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&#39;": "'",
            "&quot;": '"',
        };
        return (value || "").replace(/<\/?[^>]+(>|$)/g, "").replace(/&(\D+);/gi, tag => decodeSymbol[tag]);
    },
};
